import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SearchIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  width: '14px',
  height: '24px',
  fontSize: '14px',
}));

export const SearchButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ theme, isOpen }) => ({
  border: `solid 1px ${theme.palette.colors.mainFocused}`,
  width: 32,
  height: 32,
  borderRadius: '5px',
  borderColor: isOpen
    ? theme.palette.colors.mainFocused
    : theme.palette.colors.borderLine,
  '&:hover': {
    borderColor: theme.palette.colors.mainFocused,
    background: 'none',
  },
  [theme.breakpoints.up('xl')]: {
    display: 'none',
  },
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));
